import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { Conta } from 'src/app/admihair/api/dto/conta';
import { ContaService } from 'src/app/admihair/service/conta.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-conta-editar',
  templateUrl: './conta-editar.component.html',
  styleUrls: ['./conta-editar.component.scss']
})
export class ContaEditarComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  permissaoEditar: boolean = false;
  loading: boolean = true;
  id?: number;
  messages: Message[] = [];
  conta?: Conta;
  messagemVisivel: boolean = false;
  tipoConta: string[] = ['AJUSTE', 'BANCO', 'CAIXA'];
  tipoSelecionado: any;
  progressoRequisicao: boolean = false;


  constructor(private utilStorageService: UtilStorageService,
    private contaService: ContaService,
    private activatedRoute: ActivatedRoute,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_PLANO_CONTAS_EMPRESA');
    if (this.permissaoEditar) {
      this.carregarConta();
    }
  }

  atualizar(){
    this.progressoRequisicao = true;
    this.contaService.atualizar(this.conta, this.id).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
    
  }

  carregarConta() {
    const idParam = this.activatedRoute.snapshot.paramMap.get('id');
    if(idParam) this.id = parseInt(idParam);
    this.contaService.buscarPorId(this.id).subscribe({
      next: (data: Conta) => {
        this.conta = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    }
    )
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  limparFormulario(){
    this.form?.reset(); 
  }
  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
 
  
 
}